import {
  HTTP_INTERNAL_SERVER_ERROR,
  HTTP_FORBIDDEN,
  HTTP_UNAUTHORIZED,
  NoCreditScoreError,
  InvalidAccessTokenError,
  InvalidCompanyNumberError,
} from 'embed/shared/errors';
import { CreditScoreType, CreditScoreTypeLetter } from '../shared/types';
import { useMutation, useQuery } from 'react-query';
import { getProfileDetails, postInviteSignup } from '.';

export const useQueryGetProfileDetails = (accessToken, hasError) =>
  useQuery(
    'profileDetails',
    async () => {
      try {
        const result = await getProfileDetails(accessToken);
        const data = result?.data ?? [];
        const creditScoreType = CreditScoreTypeLetter[data?.companyInformation?.score?.grade];
        if (creditScoreType === undefined) {
          throw new NoCreditScoreError();
        }
        const {
          name: companyName,
          registrationNumber,
          score: { grade: creditScoreGrade },
        } = data?.companyInformation;
        return { companyName, registrationNumber, creditScoreGrade };
      } catch (error) {
        if (error instanceof NoCreditScoreError) {
          throw error;
        }
        const statusCode = error?.response?.status;
        if (
          statusCode &&
          [HTTP_INTERNAL_SERVER_ERROR, HTTP_FORBIDDEN, HTTP_UNAUTHORIZED].includes(statusCode)
        ) {
          throw new InvalidAccessTokenError();
        }
        throw new InvalidCompanyNumberError();
      }
    },
    { enabled: !!accessToken && !hasError, retry: false },
  );

export const useMutationPostInviteSignup = (accessToken) =>
  useMutation(async (type) => {
    const result = await postInviteSignup(accessToken, type);
    return result?.data?.url ?? '';
  });
